/* Little Lebanese quick add + bundle (2026-10-15).
   Quick add: child's first name + boy/girl only -> /cart/add.js -> /checkout. Everything else (Arabic name,
   grandparents, dedication, photo) is collected after purchase on /pages/finish-your-book (link in the order email),
   or by the order pipeline's 48h defaults. The full personaliser (ll-product.js) stays available.
   Bundle: [data-ll-bundle] forms add every listed variant with the same name/gender and _ll_bundle, then /checkout. */
(function () {
  'use strict';
  if (window.__llQuick) return; window.__llQuick = 1;
  var d = document;
  function $(s, c) { return (c || d).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); }
  function clean(v) { return (v || '').replace(/[^A-Za-z' \-]/g, '').replace(/\s+/g, ' ').slice(0, 12); }
  function track(ev, data) { try { if (window.LLtrack) window.LLtrack(ev, data); } catch (e) {} }

  function wire(box, opts) {
    var nameI = $('[data-qa-name]', box), err = $('[data-qa-err]', box), btn = $('[data-qa-go]', box);
    var label = btn.innerHTML;
    nameI.addEventListener('input', function () {
      var v = clean(nameI.value); if (v !== nameI.value) nameI.value = v;
      err.textContent = ''; if (opts.onName) opts.onName();
    });
    $$('input[type=radio]', box).forEach(function (r) { r.addEventListener('change', function () { err.textContent = ''; if (opts.onName) opts.onName(); }); });
    function gender() { var g = $('input[type=radio]:checked', box); return g ? g.value : ''; }
    function submit(e) {
      if (e) e.preventDefault();
      var n = nameI.value.trim(), g = gender();
      if (!n) { err.textContent = "Please add your child's first name."; nameI.focus(); return; }
      if (!g) { err.textContent = 'Please choose boy or girl.'; $('input[type=radio]', box).focus(); return; }
      btn.disabled = true; btn.innerHTML = 'Adding your book…';
      var props = { "Child's first name": n, 'Boy or girl': g, 'Book details': 'Finish after checkout (we email you a link)' };
      var items = opts.items().map(function (it) {
        var p = {}; for (var k in props) p[k] = props[k]; for (var j in (it.props || {})) p[j] = it.props[j];
        return { id: +it.id, quantity: 1, properties: p };
      });
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'error'); return j; }); })
        .then(function () { track('quick_add', { items: items.length }); btn.innerHTML = 'Added. Taking you to checkout…'; location.href = '/checkout'; })
        .catch(function (x) { btn.disabled = false; btn.innerHTML = label; err.textContent = 'Sorry, something went wrong (' + x.message + '). Please try again.'; });
    }
    box.addEventListener('submit', submit);
    return { gender: gender, name: nameI };
  }

  /* ---------- quick add dialog on a product page ---------- */
  var dlg = $('[data-ll-quick-add]');
  if (dlg) {
    var vid = dlg.getAttribute('data-variant'), book = d.getElementById(dlg.getAttribute('data-book') || '');
    var w = wire($('form', dlg), {
      items: function () { return [{ id: vid }]; },
      onName: function () { if (window.LLsetCover && book) window.LLsetCover(book, w.name.value, '', w.gender() || 'girl'); }
    });
    window.LLquick = {
      open: function () {
        var m = location.search.match(/[?&]name=([^&]+)/); if (m && !w.name.value) w.name.value = clean(decodeURIComponent(m[1]));
        var mg = location.search.match(/[?&]g=(Girl|Boy)\b/i); if (mg) { var rg = $('input[type=radio][value="' + (mg[1].toLowerCase() === 'boy' ? 'Boy' : 'Girl') + '"]', dlg); if (rg && !$('input[type=radio]:checked', dlg)) rg.checked = true; } /* LL 2026-10-20: from the homepage name preview */
        if (window.LLsetCover && book) window.LLsetCover(book, w.name.value, '', w.gender() || 'girl');
        if (typeof dlg.showModal === 'function') { if (!dlg.open) dlg.showModal(); } else dlg.setAttribute('open', '');
        d.documentElement.classList.add('ll-wiz-open'); setTimeout(function () { w.name.focus(); }, 30);
      }
    };
    dlg.addEventListener('close', function () { d.documentElement.classList.remove('ll-wiz-open'); });
    $$('[data-qa-close]', dlg).forEach(function (b) { b.addEventListener('click', function () { dlg.close(); }); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    $$('[data-qa-full]', dlg).forEach(function (b) { b.addEventListener('click', function (e) {
      e.preventDefault(); dlg.close(); var o = $('[data-ll-full]'); if (o) o.click();
    }); });
    $$('[data-ll-quick-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); window.LLquick.open(); }); });
  }

  /* ---------- bundle blocks ---------- */
  $$('[data-ll-bundle]').forEach(function (f) {
    var end = +f.getAttribute('data-end'); if (end && Date.now() > end) { var s = f.closest('.ll-bundle'); if (s) s.hidden = true; return; }
    var ids = (f.getAttribute('data-variants') || '').split(',').filter(Boolean), tag = f.getAttribute('data-ll-bundle');
    wire(f, { items: function () { return ids.map(function (id) { return { id: id, props: { _ll_bundle: tag } }; }); } });
  });
})();
